/**
 * Neutral chips naming the kinds of check in a proof or criterion. A chip says
 * which checks were done, not whether they passed.
 *
 * @module features/proofs/components/CheckTypeChips
 */
import React from 'react';
import { Badge } from '@chatsdet/ui';
import { checkTypeChips } from '../evidenceKinds';
import type { ProofEvidence } from '../types';

export const CheckTypeChips: React.FC<{ evidence: ProofEvidence[] }> = ({ evidence }) => (
  <>
    {checkTypeChips(evidence).map(({ type, label }) => (
      <Badge key={type} variant="secondary" size="sm" data-testid="check-type-chip">
        {label}
      </Badge>
    ))}
  </>
);
